(() => {
  const header = document.querySelector('.section-header');
  const logo = document.querySelector('[data-zlab-nav-logo]');
  if (!header || !logo || header.dataset.adaptiveNav) return;
  header.dataset.adaptiveNav = 'true';
  header.classList.add('zlab-nav-managed', 'shopify-section-header-sticky');
  logo.setAttribute('aria-controls', header.id);
  const sticky = header.querySelector('sticky-header');
  if (sticky) sticky.headerIsAlwaysSticky = true;
  let previous = window.scrollY, distance = 0, direction = 0, lockedUntil = 0, compact = false, scheduled = false;
  const drawerOpen = () => Boolean(document.querySelector('cart-drawer.active, #cart-notification.active, .menu-drawer-container[open], details-modal details[open]'));
  const update = hidden => {
    compact = hidden;
    header.classList.toggle('zlab-nav-collapsed', hidden);
    header.classList.remove('shopify-section-header-hidden');
    header.inert = hidden;
    logo.hidden = !hidden;
    logo.setAttribute('aria-expanded', String(!hidden));
    document.documentElement.style.setProperty('--zlab-navigation-height', hidden ? '0px' : header.offsetHeight + 'px');
    document.dispatchEvent(new CustomEvent('zentein:header-change', {detail: {collapsed: hidden}}));
  };
  const reveal = (hold = 1400) => { lockedUntil = Date.now() + hold; distance = 0; update(false); };
  const showForKeyboard = () => { reveal(); (header.querySelector('summary.header__icon--menu') || header.querySelector('.header__heading-link'))?.focus(); };
  logo.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') reveal(); });
  logo.addEventListener('click', event => { if (event.detail === 0) showForKeyboard(); else reveal(); });
  logo.addEventListener('focus', () => { if (logo.matches(':focus-visible')) showForKeyboard(); });
  header.addEventListener('focusin', () => reveal());
  header.addEventListener('pointerenter', () => { if (!compact) lockedUntil = Date.now() + 1400; });
  const onScroll = () => {
    scheduled = false;
    const y = Math.max(0, window.scrollY), delta = y - previous;
    previous = y;
    if (!delta) return;
    const nextDirection = Math.sign(delta);
    distance = nextDirection === direction ? distance + Math.abs(delta) : Math.abs(delta);
    direction = nextDirection;
    if (y < 140 || drawerOpen()) { update(false); return; }
    if (distance < 10) return;
    if (delta < 0) { update(false); return; }
    if (Date.now() < lockedUntil || header.matches(':hover') || (header.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) || header.querySelector('details[open]')) return;
    update(true);
  };
  window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(onScroll); } }, {passive:true});
  window.addEventListener('resize', () => update(compact));
  const cartUpdate = () => reveal(4500);
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(name => document.addEventListener(name, cartUpdate));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, cartUpdate);
  const count = header.querySelector('#cart-icon-bubble');
  if (count) new MutationObserver(cartUpdate).observe(count, {childList:true,subtree:true,characterData:true});
  update(false);
})();

